
import React from "react";
import { linksBulkImport } from "../../../api/api";
import { useFavoriteLinks } from "../../../state/api/links/useFavoriteLinks";
import { useLinks } from "../../../state/api/links/useLinks";
import { LinkBulkImport } from "../../../types/db/schema/links/link.schema";
import Button from "../buttons/Button";
import Submit from "../buttons/Submit";
import CsvParser from "../files/CsvParser";
import { Dialog, DialogBody, DialogFooter, ModalForm } from "../modal/ModalForm";
import AsAdmin from "../session/AsAdmin";

export default function LinkBulkImport() {
  return (
    <AsAdmin>
      <Dialog
        dialog={<LinkBulkImportInner />}
        trigger={<Button color="var(--bs-danger)" text="Bulk import" icon="upload" />}
      />
    </AsAdmin>
  )
}

function LinkBulkImportInner() {

  const { mutate: reloadLinks } = useLinks({ enabled: false });
  const { mutate: reloadFavoriteLinks } = useFavoriteLinks({ enabled: false });

  return (
    <ModalForm
      title="Bulk import links"
      description="Import from CSV and overwrite all existing links"
      initialValues={{
        rows: []
      } as LinkBulkImport}
      onSubmit={async (values, apiCall) => {

        const res = await apiCall(linksBulkImport(values));

        if (!res) {
          return false;
        }

        await reloadLinks();
        await reloadFavoriteLinks();

        return true;
      }}
    >
      {
        formik => (
          <>
            <DialogBody>
              <span>
                Please upload your links in a .csv file with the following format:
              </span>
              <table className="table font-s">
                <thead>
                  <tr style={{ color: "var(--gray-600)" }}>
                    <th>id</th>
                    <th>parentId</th>
                    <th>label</th>
                    <th>description</th>
                    <th>target</th>
                    <th>tags</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      1
                    </td>
                    <td>
                    </td>
                    <td>
                      Google
                    </td>
                    <td>
                      All Google Services
                    </td>
                    <td>
                    </td>
                    <td>
                      search, engine, tech
                    </td>
                  </tr>
                  <tr>
                    <td>
                      2
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Gmail
                    </td>
                    <td>
                      Email service
                    </td>
                    <td>
                      https://mail.google.com
                    </td>
                    <td>
                      email, communication
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table font-s">
                <thead style={{ color: "var(--gray-600)" }}>
                  <tr>
                    <th>
                      Field
                    </th>
                    <th>
                      Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>id</td>
                    <td>number</td>
                  </tr>
                  <tr>
                    <td>parentId</td>
                    <td>number (optional, leave empty for root links)</td>
                  </tr>
                  <tr>
                    <td>label</td>
                    <td>string</td>
                  </tr>
                  <tr>
                    <td>description</td>
                    <td>string (optional)</td>
                  </tr>
                  <tr>
                    <td>target</td>
                    <td>string (optional, empty for groups of other links)</td>
                  </tr>
                  <tr>
                    <td>tags</td>
                    <td>comma-separated string (optional)</td>
                  </tr>
                </tbody>
              </table>
              <CsvParser
                data={formik.values.rows}
                onComplete={rows => formik.setFieldValue("rows", rows)}
              />
            </DialogBody>
            <DialogFooter>
              <div className="d-flex flex-row w-100 gap-2 justify-content-between">
                <div className="d-flex flex-column" style={{ fontSize: "0.8rem", color: "var(--bs-danger)" }}>
                  <strong>WARNING:</strong>
                  <span>This will replace ALL existing links with the new ones from the CSV file.</span>
                  <span>This will also remove ALL favorites for everyone.</span>
                </div>
                <Submit color="var(--bs-danger)" text="Upload" icon="upload" />
              </div>
            </DialogFooter>
          </>
        )
      }

    </ModalForm >

  )
}